/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SchemaVersion } from './schemaVersion';
import { AddressDto } from './addressDto';


/**
 * The data required to create an RdSAP report.
 */
export interface CreateRdSapReport { 
    /**
     * When the dwelling was visited/inspected.
     */
    inspectionDate: string;
    address: AddressDto;
    schemaVersion: SchemaVersion;
}
export namespace CreateRdSapReport {
}


